import React from "react";
import autoBind from "react-autobind";

//Context
import { withGridContext } from "./grid.factory";

import Pagination from "@common/components/pagination/pagination.component";

class GridPagination extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onPageSizeChange(e) {
    const { context } = this.props;
    context.setStateAndRefresh({ pageSize: parseInt(e.target.value), pageNumber: 1 });
  }

  onChange(pageNumber) {
    const { context } = this.props;
    context.setStateAndRefresh({ pageNumber });
  }

  render() {
    const { context, hasPagination, hidBarPagination } = this.props;
    return (
        <>
            <Pagination
              hasPagination={hasPagination}
              pageNumber={context.pageNumber}
              pageSize={context.pageSize}
              setStateAndRefresh={context.setStateAndRefresh}
              pageCount={context.data.pageCount}
              onPageSizeChange={this.onPageSizeChange}
              onChange={this.onChange}
              hidBarPagination={hidBarPagination}
            />
        </>
    );
  }
}

export default withGridContext(GridPagination);
